function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "kvp-trust_svg__a",
  x1: "0%",
  x2: "100%",
  y1: "55.339%",
  y2: "55.339%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#00907F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#48D59F"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#E6E6E6",
  strokeWidth: 8,
  d: "M33 35.421a5 5 0 01-5.815 4.934l2.289 2.726 6.296-3.184a5 5 0 01-2.765-4.26L33 35.422zm5-14a5 5 0 015 5v9c0 .292-.025.578-.073.856l1.082-.548a5.077 5.077 0 01-.009-.308v-9a5 5 0 018-4V12.5a8.5 8.5 0 1117 0v75.567H31.5v-11.33a17.853 17.853 0 01-14.15-17.464v-2.47l-1.806-3.875-8.99-10.714a8.5 8.5 0 0113.023-10.927L23 35.366v-8.945a5 5 0 1110 0 5 5 0 015-5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#E6E6E6",
  strokeWidth: 4,
  d: "M44 21.421h10v25H44zm-11 0h10v25H33zm-10 0h10v25H23z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#kvp-trust_svg__a)",
  strokeWidth: 8,
  d: "M51.331 56.468L64.753 69.89l27.329-27.329",
  transform: "translate(4.565 4)"
}));

function SvgKvpTrust(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 93"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDAgOTMiPjxkZWZzPjxsaW5lYXJHcmFkaWVudCBpZD0iYSIgeDE9IjAlIiB4Mj0iMTAwJSIgeTE9IjU1LjMzOSUiIHkyPSI1NS4zMzklIj48c3RvcCBvZmZzZXQ9IjAlIiBzdG9wLWNvbG9yPSIjMDA5MDdGIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdG9wLWNvbG9yPSIjNDhENTlGIi8+PC9saW5lYXJHcmFkaWVudD48L2RlZnM+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj48cGF0aCBzdHJva2U9IiNFNkU2RTYiIHN0cm9rZS13aWR0aD0iOCIgZD0iTTMzIDM1LjQyMWE1IDUgMCAwMS01LjgxNSA0LjkzNGwyLjI4OSAyLjcyNiA2LjI5Ni0zLjE4NGE1IDUgMCAwMS0yLjc2NS00LjI2TDMzIDM1LjQyMnptNS0xNGE1IDUgMCAwMTUgNXY5YzAgLjI5Mi0uMDI1LjU3OC0uMDczLjg1NmwxLjA4Mi0uNTQ4YTUuMDc3IDUuMDc3IDAgMDEtLjAwOS0uMzA4di05YTUgNSAwIDAxOC00VjEyLjVhOC41IDguNSAwIDExMTcgMHY3NS41NjdIMzEuNXYtMTEuMzNhMTcuODUzIDE3Ljg1MyAwIDAxLTE0LjE1LTE3LjQ2NHYtMi40N2wtMS44MDYtMy44NzUtOC45OS0xMC43MTRhOC41IDguNSAwIDAxMTMuMDIzLTEwLjkyN0wyMyAzNS4zNjZ2LTguOTQ1YTUgNSAwIDExMTAgMCA1IDUgMCAwMTUtNXoiLz48cGF0aCBmaWxsPSIjRkZGIiBzdHJva2U9IiNFNkU2RTYiIHN0cm9rZS13aWR0aD0iNCIgZD0iTTQ0IDIxLjQyMWgxMHYyNUg0NHpNMzMgMjEuNDIxaDEwdjI1SDMzek0yMyAyMS40MjFoMTB2MjVIMjN6Ii8+PHBhdGggc3Ryb2tlPSJ1cmwoI2EpIiBzdHJva2Utd2lkdGg9IjgiIGQ9Ik01MS4zMzEgNTYuNDY4TDY0Ljc1MyA2OS44OWwyNy4zMjktMjcuMzI5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0LjU2NSA0KSIvPjwvZz48L3N2Zz4K";
export { SvgKvpTrust as ReactComponent };